import React, { useState } from "react";
import axios from "axios";
import styles from "../assets/css/pickups.module.css";
import { Link } from "react-router-dom";

export default function Pickups() {
  const [accountNumber, setAccountNumber] = useState("");
  const [pickupsData, setPickupsData] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const runnerData = JSON.parse(localStorage.getItem("runnerData"));
  const { accessToken, runnerID, companyID } = runnerData;

  const handleSearch = async (e) => {
    e.preventDefault();
    try {
      setIsLoading(true);
      const response = await axios.get(
        `https://vsoftrunners.com-eg.net/api/RunnerUsers/V7/GetPickupsByAccountNo/${runnerID}/${accountNumber}`,
        {
          headers: {
            companyID: companyID,
            accessToken: accessToken,
          },
        }
      );
      setPickupsData(response.data);
      setIsLoading(false);
    } catch (error) {
      console.error("Error fetching pickups data:", error);
      setIsLoading(false);
    }
  };
  return (
    <>
      <div className={styles.container}>
        <form onSubmit={handleSearch}>
          <div className={styles.accountContainer}>
            <label>Account Number</label>
            <input
              className={styles.accountNumberInput}
              required
              type="text"
              value={accountNumber}
              onChange={(e) => setAccountNumber(e.target.value)}
            />
          </div>
          <button className={styles.searchButton} type="submit">
            Search
          </button>
          {isLoading && <div className={styles.loader}></div>}
        </form>
        {pickupsData?.length > 0 ? (
          <div className={styles.tableContainer}>
            <table className={styles.contentTable}>
              <thead>
                <tr>
                  <th>PickUps</th>
                </tr>
              </thead>
              <tbody>
                {pickupsData?.map((pickup) => (
                  <tr key={pickup.PickupID}>
                    <Link
                      style={{ textDecoration: "none", color: "green" }}
                      to={`/scan-pickups/shipments-of-pickup/${pickup.PickupID}`}
                    >
                      <td>{pickup.PickupID}</td>
                    </Link>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : pickupsData?.length === 0 ? (
          <div className={styles.noPickupsCard}>No PickUps</div>
        ) : pickupsData ? (
          <></>
        ) : (
          <></>
        )}
      </div>
    </>
  );
}
